import CONST from 'constants/app.constants';

export default function CarsInterceptor($httpProvider) {
    'ngInject';

        const carSearchUrl = CONST.apiUrl + '/cars/Search';

        $httpProvider.interceptors.push(['userService',
            function(userService) {
                return {
                    request: function(config) {

                        /**
                         * Localization settings
                         */
                        const regionalSettings = userService.getRegionalSettings();
                        const _config = angular.copy(config);
                        if (_config.method === 'GET' && _config.url.indexOf(carSearchUrl) === 0) {
                            _config.params.PickUpDate
                                = moment(_config.params.PickUpDate, regionalSettings.dateTimeFormat)
                                    .format(regionalSettings.ISO);
                            _config.params.DropOffDate
                                = moment(_config.params.DropOffDate, regionalSettings.dateTimeFormat)
                                    .format(regionalSettings.ISO);
                        }
                        return _config;
                    },
                };
            },
        ]);
}



// WEBPACK FOOTER //
// ./src/app/modules/cars/services/cars.interceptor.js